window.acom_app = {
    data: {},
    models: {},
    collections: {},
    views: {}
}